import AgGridLayout from '@/components/wrappers/layouts/AgGridLayout';
import { Button, Col, Form, Input, Row, Select, Tabs, TabsProps } from 'antd';
import { useState } from 'react'

const TagsMappingComponent = () => {
    const { Option } = Select;
    const [activeTab, setActiveTab] = useState<string>("1");
    const [tagMappingForm] = Form.useForm();

    const tapMappingColumnDefs = [
        {
            headerName: "Category",
            field: "category",
            sortable: true,
            filter: true,
            width: 200,
            cellStyle: {
                textAlign: "center",
            },
        },
        {
            headerName: "Sub-Category",
            field: "sub_category",
            sortable: true,
            filter: true,
            width: 200,
            cellStyle: {
                textAlign: "center",
            },
        },
        {
            headerName: "Segment",
            field: "segment",
            sortable: true,
            filter: true,
            width: 200,
            cellStyle: {
                textAlign: "center",
            },
        },
        {
            headerName: "Brand",
            field: "brand",
            sortable: true,
            filter: true,
            width: 200,
            cellStyle: {
                textAlign: "center",
            },
        },
        activeTab === "2"
            ? {
                headerName: "Action",
                field: "action",
                sortable: true,
                filter: true,
                width: 200,
                cellStyle: {
                    textAlign: "center",
                },
            }
            : {},
    ];

    const tagMappingTabItems: TabsProps["items"] = [
        {
            key: "1",
            label: "Create New Mapping",
            children: (
                <>
                    <div className="border" style={{ background: "#efefef" }}>
                        <Form
                            name="tag_mapping_form"
                            layout="vertical"
                            form={tagMappingForm}
                            // style={{ maxWidth: 600 }}
                        >
                            <Row className="mt-3">
                                <Col
                                    span={18}
                                    className="d-flex align-items-center justify-content-around"
                                >
                                    <Form.Item
                                        label="Mapping Name"
                                        name="mapping_name"
                                        rules={[
                                            {
                                                required: true,
                                                message:
                                                    "Please input Mapping Name",
                                            },
                                        ]}
                                    >
                                        <Input
                                            placeholder="Name"
                                            className="border"
                                        />
                                    </Form.Item>

                                    <Form.Item
                                        label="First Level"
                                        name="first_level"
                                        rules={[
                                            {
                                                required: true,
                                                message:
                                                    "Please select First Level",
                                            },
                                        ]}
                                        style={{ width: 150 }}
                                    >
                                        <Select
                                            className=""
                                            mode="multiple"
                                            placeholder="Category"
                                        >
                                            {/* <Option ></Option> */}
                                        </Select>
                                    </Form.Item>

                                    <Form.Item
                                        label="Second Level"
                                        name="second_level"
                                        rules={[
                                            {
                                                required: true,
                                                message:
                                                    "Please select Second Level",
                                            },
                                        ]}
                                        style={{ width: 150 }}
                                    >
                                        <Select
                                            className=""
                                            mode="multiple"
                                            placeholder="Sub Category"
                                        >

                                        </Select>
                                    </Form.Item>

                                    <Form.Item
                                        label="Third Level"
                                        name="record_type"
                                        rules={[
                                            {
                                                required: true,
                                                message:
                                                    "Please select Third Level",
                                            },
                                        ]}
                                        style={{ width: 150 }}
                                    >
                                        <Select
                                            className=""
                                            mode="multiple"
                                            placeholder="Segment"
                                        >

                                        </Select>
                                    </Form.Item>

                                    <Form.Item
                                        label="Fourth Level"
                                        name="fourth_level"
                                        rules={[
                                            {
                                                required: true,
                                                message:
                                                    "Please select Fourth Level",
                                            },
                                        ]}
                                        style={{ position: "relative" }}
                                        className="d-flex justify-content-end"
                                    >
                                        <Select
                                            className=""
                                            mode="multiple"
                                            placeholder="Brand"
                                            style={{ width: 150 }}
                                        >

                                        </Select>
                                        <span
                                            className="text-primary text-decoration-underline"
                                            style={{
                                                position: "absolute",
                                                right: "5px",
                                                bottom: "-22px",
                                            }}
                                        >
                                            Add More levels
                                        </span>
                                    </Form.Item>
                                </Col>

                                <Col
                                    span={4}
                                    className="d-flex align-items-center justify-content-start"
                                >
                                    <Form.Item className="mt-4">
                                        <Button
                                            type="primary"
                                            className="mt-1"
                                            htmlType="submit"
                                        >
                                            Save Mapping and Create Table
                                        </Button>
                                    </Form.Item>
                                </Col>
                            </Row>
                        </Form>
                    </div>
                    <div
                        className="ag-theme-alpine border mt-3"
                        style={{ height: "250px" }}
                    >
                        <AgGridLayout
                            rowData={[]}
                            columnDefs={tapMappingColumnDefs}
                            isTotalRowsReq={false}
                        />
                    </div>
                </>
            ),
        },
        {
            key: "2",
            label: "Mapped Tags",
            children: (
                <div>
                    <div className="text-end">
                        <span>Select Mapping</span>
                        <Select
                            className="ms-2 text-start"
                            style={{
                                width: 180,
                            }}
                            mode="multiple"
                            placeholder="Select mapping Type"
                            options={[
                                {
                                    value: "Category",
                                    label: "Sub Cat Mapping",
                                },
                            ]}
                        />
                    </div>

                    <div
                        className="ag-theme-alpine border mt-3"
                        style={{ height: "250px" }}
                    >
                        <AgGridLayout
                            rowData={[]}
                            columnDefs={tapMappingColumnDefs}
                            isTotalRowsReq={false}
                        />
                    </div>
                </div>
            ),
        },
    ];


    return (
        <div>
            <Tabs
                size="large"
                defaultActiveKey={activeTab}
                items={tagMappingTabItems}
                onChange={(k) => {
                    setActiveTab(k);
                }}
            />
        </div>
    )
}

export default TagsMappingComponent